import {
  CustomerAction,
  DeviceAction,
  FacilityAction,
  OwnershipAction,
  PartnerAction,
  SubscriptionAction,
  TicketAction,
  UserAction,
  VehicleAction,
} from '../enums';

export const Actions = {
  ...PartnerAction,
  ...UserAction,
  ...DeviceAction,
  ...VehicleAction,
  ...OwnershipAction,
  ...SubscriptionAction,
  ...CustomerAction,
  ...TicketAction,
  ...FacilityAction,
};
